import { BaseDto } from "src/dtos/common/baseDto";

export interface TqcDailyInspectionDto extends BaseDto {
	compCd: string;
	inspectionType: string;
	inspectionDt: string;
	numval_01: number;
	numval_02: number;
	numval_03: number;
	numval_04: number;
	numval_05: number;
	numval_06: number;
	numval_07: number;
	numval_08: number;
	numval_09: number;
	numval_10: number;
	txtval_01: string;
	txtval_02: string;
	txtval_03: string;
	txtval_04: string;
	txtval_05: string;
	txtval_06: string;
	txtval_07: string;
	txtval_08: string;
	txtval_09: string;
	txtval_10: string;
	remark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcDailyInspectionDto: TqcDailyInspectionDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	compCd: '',
	inspectionType: '',
	inspectionDt: '',
	numval_01: 0,
	numval_02: 0,
	numval_03: 0,
	numval_04: 0,
	numval_05: 0,
	numval_06: 0,
	numval_07: 0,
	numval_08: 0,
	numval_09: 0,
	numval_10: 0,
	txtval_01: '',
	txtval_02: '',
	txtval_03: '',
	txtval_04: '',
	txtval_05: '',
	txtval_06: '',
	txtval_07: '',
	txtval_08: '',
	txtval_09: '',
	txtval_10: '',
	remark: '',
	inserted: false,
	isModified: false,
};
